export default "__VITE_PUBLIC_ASSET__3534e3e6__"